import { injectable } from "inversify";
import IAlertService from "./IAlertService";
import Vue from "vue";
import { MessageTypeEnum } from "../../models/enums/MessageTypeEnum";
@injectable()
/** Интерфейс вывода сообщений клиенту*/
export default class AlertService implements IAlertService {
  /** Вывод ошибки */
  public async success(message: string, autoHide: boolean = true, clickFunc: Function = null): Promise<void> {
    await this.show(message, MessageTypeEnum.Success, autoHide, clickFunc);
  }
  /** Вывод ошибки */
  public async error(message: string, autoHide: boolean = true, clickFunc: Function = null): Promise<void> {
    await this.show(message, MessageTypeEnum.Error, autoHide, clickFunc);
  }
  /** Вывод предупреждения */
  public async warning(message: string, autoHide: boolean = true, clickFunc: Function = null): Promise<void> {
    await this.show(message, MessageTypeEnum.Warning, autoHide, clickFunc);
  }
  /** Вывод сообщения */
  public async info(message: string, autoHide: boolean = true, clickFunc: Function = null): Promise<void> {
    await this.show(message, MessageTypeEnum.Info, autoHide, clickFunc);
  }

  /** Вывод сбп */
  public async sbp(message: string, autoHide: boolean = true, clickFunc: Function = null): Promise<void> {
    await this.show(message, MessageTypeEnum.Sbp, autoHide, clickFunc);
  }

  /** Вывод сбп */
  public async show(message: string, type: MessageTypeEnum, autoHide?: boolean, clickFunc?: Function): Promise<void> {
    Vue.$toast.open({
      message: message,
      type: type,
      dismissible: true,
      duration: autoHide ? 5000 : 5000 * 10000,
      onClick: () => { if (clickFunc) clickFunc() }
    });
  }

  /** Очистка сообщений */
  public async clear(): Promise<void> {
    Vue.$toast.clear();
  }
}
